import {
  BicycleLg,
  CarLg,
  CarMd,
  PersonWalkingFilledLg,
  PersonWalkingFilledMd,
  TrainLg,
  TrainMd,
} from '@property.com.au/ui-kit';
import type { CommuteMethod } from '../types';

export const mapCommuteMethodToIcon = (
  commuteMethod: CommuteMethod,
  size: 'Md' | 'Lg' = 'Md',
): React.ReactNode => {
  const isLargeSize = size === 'Lg';
  switch (commuteMethod) {
    case 'walking':
      return isLargeSize ? <PersonWalkingFilledLg /> : <PersonWalkingFilledMd />;
    case 'cycling':
      // At this stage CK doesn't have a MD Bicycle icon so we're returning Lg and using CSS to scale it down
      return <BicycleLg />;
    case 'public_transport':
      return isLargeSize ? <TrainLg /> : <TrainMd />;
    case 'driving':
      return isLargeSize ? <CarLg /> : <CarMd />;
  }
};
